import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import {
  repairsData,
  repairsDataPost,
  repairsDataDelete,
  repairsDataID,
} from "./repairsActions";
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";
import { RepairRequest } from '../../types/request.type';
import { initRepairsResponse } from "./createNewRepairSlice";

type RepairRequestState = {
    repairRequest: RepairRequest;
    loading: boolean;
    success: boolean;
    error: string | null;
};

const initialState: RepairRequestState = {
  repairRequest: initRepairsResponse,
    loading: false,
    success: false,
    error: ""
};

const repairRequestSliceID = createSlice({
  name: "repairs",
  initialState: initialState,
  reducers: {
    // Обычные редьюсеры
    setRepairsState(state, action: PayloadAction<RepairRequest>) {
      // state.dataRepairsID.payload = [];
      state.repairRequest = action.payload;
    },

    setRepairState(state, action: PayloadAction<RepairRequest>) {
      // state.repairRequest = [];
      state.repairRequest = action.payload;
    },


  },

  extraReducers: (builder) => {
    builder
     
      .addCase(repairsDataID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(repairsDataID.fulfilled, (state, action) => {
        state.loading = false;

        repairRequestSliceID.caseReducers.setRepairState(state, action);
      })
      .addCase(repairsDataID.rejected, (state, action) => {
        state.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.error = errorText ? errorText : "";
      });
  },
});


const getErrorText = (error: ErrorResponse) => {
 // console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
};

export const repairRequestReducerID = repairRequestSliceID.reducer;
